// useLeads — replaces src/hooks/useLeads.js (Firebase version).
// Same return shape: { leads, loading, error }
// No changes needed in any page or component that consumes this hook.

import { useEffect, useState } from 'react';
import { subscribeLeads } from '../lib/leads';

export function useLeads() {
  const [leads, setLeads]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    const unsub = subscribeLeads(
      (rows) => {
        setLeads(rows);
        setLoading(false);
        setError(null);
      },
      (err) => {
        console.warn('[useLeads] subscription error:', err?.message);
        // Normalise Supabase error codes to match what Dashboard/Pipeline already check.
        // Supabase RLS denial = PostgreSQL error code 42501.
        setError({
          code:    err?.code === '42501' ? 'permission-denied' : (err?.code || 'unknown'),
          message: err?.message || String(err)
        });
        setLoading(false);
      }
    );
    return unsub;
  }, []);

  return { leads, loading, error };
}
